import { render } from "./AddFriendDialog.vue?vue&type=template&id=25563f3e&scoped=true"
import script from "./AddFriendDialog.vue?vue&type=script&lang=js"
export * from "./AddFriendDialog.vue?vue&type=script&lang=js"

import "./AddFriendDialog.vue?vue&type=style&index=0&id=25563f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25563f3e"]])

export default __exports__